export const DEVICE_TYPE_DESKTOP = 'desktop';
export const DEVICE_TYPE_MOBILE = 'mobile';
export function getDeviceType(): string {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return DEVICE_TYPE_DESKTOP;
    }
    const userAgent = navigator.userAgent;
    if (/Mobi|Android/i.test(userAgent)) {
        return DEVICE_TYPE_MOBILE;
    }
    return DEVICE_TYPE_DESKTOP;
}
